// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-nav-page__tabs{margin-bottom:40px}.page-modal-opened .g-mask--modal{opacity:0!important}.f-rte .a-dropdown__options ul:not(:last-child){margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
